import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/siteInfo';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20serene%20abstract%20digital%20landscape%20with%20soft%20warm%20golden%20and%20cream%20gradients%2C%20flowing%20organic%20shapes%20suggesting%20light%20and%20calm%2C%20minimalist%20artistic%20style%2C%20gentle%20ambient%20atmosphere%2C%20no%20hard%20edges%2C%20ethereal%20and%20peaceful%20mood%2C%20warm%20tones%20with%20subtle%20texture&width=1920&height=1080&seq=hero-bg-nagihikari&orientation=landscape"
          alt="凪光在线背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50/20 backdrop-blur-sm rounded-full border border-background-50/20 mb-8">
          <span className="w-2 h-2 bg-accent-400 rounded-full animate-pulse"></span>
          <span className="text-xs text-background-50 font-medium">平台稳定运行中 · 服务超过 500 万用户</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-semibold text-background-50 mb-6 leading-tight">
          流畅稳定的在线体验
          <br />
          <span className="text-primary-400">从这里开始</span>
        </h1>

        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          {siteInfo.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/platform-guide"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            立即开始使用
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 font-medium rounded-full border border-background-50/25 hover:bg-background-50/25 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            了解更多
            <i className="ri-information-line ml-2"></i>
          </Link>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {[
            { value: '500万+', label: '累计用户' },
            { value: '98.6%', label: '用户满意度' },
            { value: '6年', label: '稳定运营' },
            { value: '24/7', label: '在线支持' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}